// Per-recon column rules that ReconTable applies on top of the wire's `recon.columns` order —
// kept apart from reconciliationsCopy.ts (which is tooltip/caption text) because these are
// structural (what renders at all, and what glyph a header carries), not wording.

// The header `+ / − / =` glyph, keyed by recon id THEN column key — never by column key
// alone, since a key like `equityPas3` or `debtSchedule` is reused across recons with different
// meaning (e.g. debtSchedule is '=' under Debt but carries no operator under New Sanctions).
export const COLUMN_OPERATORS: Record<string, Record<string, '+' | '−' | '='>> = {
    accountReceivables: { revenueSourceGst: '+', revenueSourcePnl: '+', collections: '−', revenueGst: '=', revenuePnl: '=' },
    accountPayables: { expensesPnl: '+', payments: '−', expectedPayables: '=' },
    cashBurn: { investingNetCfs: '+', cashBurnCfs: '=' },
    debt: { newDebt: '+', newDebtDs: '+', repayments: '−', repaymentsDs: '−', debtBank: '=', debtSchedule: '=' },
    netWorth: { pat: '+', equityPas3: '+', calculatedNetWorth: '=' },
};

export const columnOperator = (reconId: string, columnKey: string): string | undefined => COLUMN_OPERATORS[reconId]?.[columnKey];

// Drill-down cells that read as reference figures rather than scored results (grey ground), keyed
// recon id THEN column key like COLUMN_OPERATORS. Delete the entry to undo.
export const DRILL_DOWN_REFERENCE_COLUMNS: Record<string, string[]> = {
    revenue: ['gstr3b'],
};

export const isDrillDownReferenceColumn = (reconId: string, columnKey: string): boolean =>
    DRILL_DOWN_REFERENCE_COLUMNS[reconId]?.includes(columnKey) ?? false;
